import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Form, RadioButton } from 'fw/forms';
import { Button, Box } from 'fw/components';
import * as Modals from 'fw/globals/Modals'

class RadioButtonDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				radioDemo: "PRE"
			}
		};
	}

	onChange = (form) => {
		this.setState({ form });
	}

	onSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	render() {
		return (
			<Box title="RadioButton">
				<Form
					onChange={this.onChange}
					values={this.state.form}
					onSubmit={this.onSubmit}>
					<Row>
						<Col md={4}>
							<RadioButton name="radioDemo" option="DEF" label="Default"/>
						</Col>
						<Col md={4}>
							<RadioButton name="radioDemo" option="PRE" label="Preset" checked={true} />
						</Col>
						<Col md={4}>
							<RadioButton name="radioDemo" option="DIS" label="Disabled" disabled={true} />
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default RadioButtonDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/RadioButtonDemo.js